/**
 * pxpFAQ Global Accordion Manager
 * Ensures only one FAQ accordion can be open at a time across all FAQ components on the page
 */

var $ = require('jquery');

/**
 * Initialize global FAQ accordion behavior
 */
function initGlobalFAQAccordion() {
    // Handle FAQ toggle click events - prevent default and manage manually
    $(document).on('click', '.pxp-faq-toggle', function (event) {
        event.preventDefault();
        
        var $clickedButton = $(this);
        var targetSelector = $clickedButton.attr('data-target');
        var $clickedCollapse = $(targetSelector);
        var isCurrentlyExpanded = $clickedCollapse.hasClass('show');
        
        // Close all other open FAQ accordions first
        $('.pxp-faq-collapse.show').each(function () {
            var $openCollapse = $(this);
            var openCollapseId = $openCollapse.attr('id');
            
            // Skip the accordion we're about to toggle
            if (openCollapseId !== $clickedCollapse.attr('id')) {
                // Find the corresponding button
                var $correspondingButton = $('[data-target="#' + openCollapseId + '"]');
                
                // Close the accordion manually with animation
                var currentHeight = $openCollapse[0].scrollHeight;
                $openCollapse.css('height', currentHeight + 'px');
                
                // Force a reflow, then animate to 0
                setTimeout(function () {
                    $openCollapse.removeClass('show');
                    $openCollapse.css('height', '1px');
                }, 10);
                
                // Update button state
                $correspondingButton.addClass('collapsed');
                $correspondingButton.attr('aria-expanded', 'false');
            }
        });
        
        // Now toggle the clicked accordion with smooth animation
        if (isCurrentlyExpanded) {
            // Close the clicked accordion
            var currentHeight = $clickedCollapse[0].scrollHeight;
            $clickedCollapse.css('height', currentHeight + 'px');
            
            // Force a reflow, then animate to 0
            setTimeout(function () {
                $clickedCollapse.removeClass('show');
                $clickedCollapse.css('height', '1px');
            }, 10);
            
            $clickedButton.addClass('collapsed');
            $clickedButton.attr('aria-expanded', 'false');
        } else {
            // Open the clicked accordion
            $clickedCollapse.css('height', '1px');
            $clickedCollapse.addClass('show');
            
            // Get the natural height and animate to it
            var targetHeight = $clickedCollapse[0].scrollHeight;
            setTimeout(function () {
                $clickedCollapse.css('height', targetHeight + 'px');
            }, 10);
            
            // After animation, set to auto for responsive behavior
            setTimeout(function () {
                if ($clickedCollapse.hasClass('show')) {
                    $clickedCollapse.css('height', 'auto');
                }
            }, 350); // Match the CSS transition duration
            
            $clickedButton.removeClass('collapsed');
            $clickedButton.attr('aria-expanded', 'true');
        }
    });
}

module.exports = {
    init: initGlobalFAQAccordion
};

// Auto-initialize when DOM is ready
$(document).ready(function () {
    initGlobalFAQAccordion();
});